export const SORT_OPTIONS = [
  { key: 'incorrectMarks', label: 'Worst' },
  { key: 'correctMarks', label: 'Best' },
  { key: 'sillyMarks', label: 'Silly Mistakes' },
  { key: 'inaccuracyMarks', label: 'Inaccuracies' },
  { key: 'missedMarks', label: 'Missed Marks' },
];
